'use client';

import { forwardRef } from 'react';
import { LinkProps } from 'next/link';

import { Link as NextIntlLink } from '@/i18n/routing';
import { cn } from '@/lib/utils';

export interface CustomLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> {
    href: string;
    className?: string;
    children: React.ReactNode;
}

const Link = forwardRef<HTMLAnchorElement, CustomLinkProps>(({ href, className, children, ...props }, ref) => {
    return (
        <NextIntlLink href={href} className={cn(className)} ref={ref} {...props}>
            {children}
        </NextIntlLink>
    );
});

Link.displayName = 'Link';

export { Link };
